import {
   ChangeDetectionStrategy,
   Component,
   EventEmitter,
   Input,
   OnDestroy,
   OnInit,
   Output,
   ViewEncapsulation,
} from '@angular/core';
import { CallState } from '@lcs/shared/api';
import { ReportParameterFormService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { Store } from '@ngrx/store';
import { TileTypes } from 'generated/graphql-types';
//import { ContextHelpIds } from '@qmanage/core/context-help/context-help';
//import { getIsNdtEnabled } from '@qmanage/core/store/system-preferences/system-preferences.selectors';
//import { searchDebounce } from '@qmanage/core/utils/search-debounce-rxjs';
//import { QmgScreensizeBreakpointsService } from '@qmanage/qManage/site-layout/services/qmg-screensize-breakpoints.service';
//import { ReportParameterFormService } from '@qmanage/reports/shared/report-parameter-list/services/report-parameter-form.service';
//import { IntegrationTileTypes, TileTypes } from 'generated/graphql-types';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { searchDebounce } from 'src/app/common-components/utils/search-debounce-rxjs';
//import { TileSet, TileSetType } from '../../tile-set-type-select/models/tile-set.model';
import { Tile } from 'src/app/pages/tiles/models/tile.model';
import { PreviewDashboardTile } from '../../models/dashboard-tile.model';
import { TileSet, TileSetType } from '../../tile-set-type-select/models/tile-set.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-dashboard-tile-view',
    templateUrl: './add-dashboard-tile-view.component.html',
    styleUrls: ['./add-dashboard-tile-view.component.scss'],
    host: {
        class: 'add-dashboard-view-wrapper',
    },
    standalone: false
})
export class AddDashboardTileViewComponent implements OnInit, OnDestroy {
   @Input() tileSets: TileSet[] = [];

   //@Input() customTileSet: TileSet;

   @Input() callState: CallState;

   @Input() searchText: string | null;

   @Output() searchTextChange = new EventEmitter<string>();

   @Output() formCanceled = new EventEmitter<void>();

   @Output() addTile = new EventEmitter<{
      previewTileConfig: PreviewDashboardTile | null;
      formService: ReportParameterFormService<any>;
   }>();

   //contextHelpIds = ContextHelpIds;

   selectedCustomTile: Tile | null = null;

   selectedDesignerTileSet: TileSet | null = null;

   selectedDesignerTileSetType: TileSetType | null = null;

   mobileView$: Observable<boolean>;

   isNdtEnabled: boolean;

   private customTabScrollTop: number = 0;

   private designerTabScrollTop: number = 0;

   private destroyed$ = new Subject<void>();

   private searchTextChangeSubsciption = new Subject<string>();

   // constructor(qmgScreensizeBreakpointsService: QmgScreensizeBreakpointsService, private store: Store) {
   //    this.mobileView$ = qmgScreensizeBreakpointsService.screensizeIsMobile();
   // }
   constructor(private store: Store) {}

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   ngOnInit(): void {
      this.searchTextChangeSubsciption
         //searchDebounce(),
         .pipe(searchDebounce(), distinctUntilChanged(), takeUntil(this.destroyed$))
         .subscribe((searchText: string) => {
            this.searchTextChange.emit(searchText);
         });

      // this.store
      //    .pipe(select(getIsNdtEnabled))
      //    .pipe(takeUntil(this.destroyed$))
      //    .subscribe((isNdtEnabled) => {
      //       this.isNdtEnabled = isNdtEnabled;
      //    });
   }

   onSearchTextChange(searchText: string): void {
      this.searchTextChangeSubsciption.next(searchText);
   }

   onAddTile(payload: {
      previewTileConfig: PreviewDashboardTile | null;
      formService: ReportParameterFormService<any>;
   }) {
      this.addTile.emit({ previewTileConfig: payload.previewTileConfig, formService: payload.formService });
   }

   // isTileSetNotLicensed(tileSet: TileSet): { notLicensed: boolean; integrationTypeId: IntegrationTileTypes | null } {
   //    const { tileSetTypes } = tileSet;
   //    for (let i = 0; i < tileSetTypes.length; i++) {
   //       const integrationTypeId = tileSetTypes[i].tile.integrationTypeId;
   //       if (
   //          !this.isNdtEnabled &&
   //          integrationTypeId &&
   //          this.getIntegrationTileType(integrationTypeId) === IntegrationTileTypes.NDT
   //       ) {
   //          return { notLicensed: true, integrationTypeId };
   //       }
   //    }
   //    return { notLicensed: false, integrationTypeId: null };
   // }

   // onNextCustomTile(tile: Tile | null) {
   //    if (tile !== null) {
   //       this.customTabScrollTop = this.getTabScrollParent('custom')?.scrollTop ?? 0;
   //    }
   //    if (tile === null) {
   //       requestAnimationFrame(() => {
   //          this.getTabScrollParent('custom')?.scrollTo({ top: this.customTabScrollTop });
   //       });
   //    }
   //    this.selectedCustomTile = tile;
   // }

   onNextDesignerTileSet(tileSet: TileSet | null) {
      if (tileSet !== null) {
         this.designerTabScrollTop = this.getTabScrollParent('designer')?.scrollTop ?? 0;
      }
      if (tileSet === null) {
         requestAnimationFrame(() => {
            this.getTabScrollParent('designer')?.scrollTo({ top: this.designerTabScrollTop });
         });
      }
      this.selectedDesignerTileSet = tileSet;
      this.selectedDesignerTileSetType = tileSet?.tileSetTypes[0] ?? null;
   }

   onTabChange(index) {
      this.designerTabScrollTop = 0;
      this.customTabScrollTop = 0;
      if (index === 0) {
         this.onNextDesignerTileSet(null);
      }
      // if (index === 1) {
      //    this.onNextCustomTile(null);
      // }
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onDesignerTileSetTypeChange(tileSetType: TileSetType) {
      this.selectedDesignerTileSetType = tileSetType;
   }

   // onCustomTileSetTypeChange(tileSetType: TileSetType) {
   //    this.selectedCustomTile =
   //       this.customTileSet.tileSetTypes.find((t) => t.tile.tileId === tileSetType.tile.tileId)?.tile ?? null;
   // }

   getTileSetTypes(tileSet: TileSet): TileTypes[] | null {
      return tileSet.tileSetTypes.filter((tst) => !!tst.tile.typeId).map((tst) => tst.tile.typeId!);
   }

   private getTabScrollParent(tab: 'designer' | 'custom') {
      return document.querySelector(`.${tab}-tiles-group .add-tile-tab .tiles`);
   }

   // private getIntegrationTileType(value: IntegrationTileTypes): string | null {
   //    switch (value) {
   //       case IntegrationTileTypes.NDT:
   //          return 'NDT';
   //       default:
   //          return null;
   //    }
   // }
}
